<mat-nav-list class="sidebar-nav">
  <div class="sidebar-header">
    <div class="lms-box">
      <span class="lms-text">LMS</span>
      <div class="dashboard-container">
        <span class="dashboard-text">DASHBOARD</span>
      </div>
    </div>
  </div>
  <mat-divider class="white-divider"></mat-divider>

  <div class="user-profile">
    <div class="user-initials-circle">
      <span>{{ userInitials }}</span>
    </div>
    <div class="user-name">
      {{ this.userName }} {{ this.userSurname }}
    </div>
  </div>

  <div class="user-actions">
    <button mat-button class="action-link" (click)="onResetPassword()">Reset Password</button>
    <span class="action-divider"></span>
    <button mat-button class="action-link" (click)="onLogout()">Logout</button>
  </div>

  <mat-divider class="white-divider"></mat-divider>

  <ng-container *ngFor="let item of accessibleNavItems">
    <a mat-list-item [routerLink]="item.link" routerLinkActive="active">
      <mat-icon matListItemIcon class="white-icon">{{ item.icon }}</mat-icon>
      <span class="nav-text">{{ item.text }}</span>
    </a>
    <mat-divider *ngIf="item.dividerAfter" class="white-divider"></mat-divider>
  </ng-container>

  <div class="sidebar-toggle-container">
    <button mat-icon-button class="sidebar-toggle-button" (click)="onToggleClick()"
            [attr.aria-label]="isExpanded ? 'Collapse sidebar' : 'Expand sidebar'">
      <mat-icon *ngIf="isExpanded">chevron_left</mat-icon>
      <mat-icon *ngIf="!isExpanded">chevron_right</mat-icon>
    </button>
  </div>
</mat-nav-list>